import Vue from 'vue'
import Main from './Main.vue'
import router from './router'
import store from './store'
import webTools from './tools/web/webTools';

Vue.config.productionTip = false
webTools.init()

new Vue({
  router,
  store,
  render: function (h) { return h(Main) }
}).$mount('#app')
